import BronzeBack from '../assets/images/coin-bronze-back.png';
import BronzeFront from '../assets/images/coin-bronze-front.png';
import GoldBack from '../assets/images/coin-gold-back.png';
import GoldFront from '../assets/images/coin-gold-front.png';
import SilverBack from '../assets/images/coin-silver-back.png';
import SilverFront from '../assets/images/coin-silver-front.png';
import type { CoinTier } from '../types/coin';

export const coinTiers: CoinTier[] = [
  {
    id: 'bronze',
    name: 'Bronze',
    finish: 'antique',
    contributionRange: '$100 to $499',
    frontImage: BronzeFront,
    backImage: BronzeBack,
    stripeUrl: 'https://buy.stripe.com/7sY5kEfpQe4f3J15US3VC01',
  },
  {
    id: 'silver',
    name: 'Silver',
    finish: 'antique',
    contributionRange: '$500 to $999',
    frontImage: SilverFront,
    backImage: SilverBack,
    stripeUrl: 'https://buy.stripe.com/aFafZi0uWe4f4N54QO3VC02',
  },
  {
    id: 'gold',
    name: 'Gold',
    finish: 'antique',
    contributionRange: '$1,000 to $4,999',
    frontImage: GoldFront,
    backImage: GoldBack,
    stripeUrl: 'https://buy.stripe.com/dRmcN6elM9NZcfx8303VC03',
  },
  {
    id: 'shiny-silver',
    name: 'Shiny Silver',
    finish: 'premium',
    contributionRange: '$5,000 to $9,999',
    frontImage: SilverFront,
    backImage: SilverBack,
    stripeUrl: 'https://buy.stripe.com/6oUcN61z02lxcfxfvs3VC04',
  },
  {
    id: 'shiny-gold',
    name: 'Shiny Gold',
    finish: 'premium',
    contributionRange: '$10,000 and above',
    frontImage: GoldFront,
    backImage: GoldBack,
    stripeUrl: 'https://buy.stripe.com/cNi8wQ4Lc0dp4N53MK3VC05',
  },
];
